import { HttpErrorResponse, HttpInterceptorFn, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { timeout, catchError, throwError, switchMap } from 'rxjs';
import { AuthService } from '@shared/services/auth.service';
import { environment } from '@environments';

function addToken(req: HttpRequest<unknown>, token: string | null): HttpRequest<unknown> {
  if (token && !req.url.includes('/start')) {
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return req;
}

const RETRYABLE_AUTH_STATUSES = [HttpStatusCode.Unauthorized, HttpStatusCode.Forbidden];

function isRetryableAuthError(status: number): boolean {
  return RETRYABLE_AUTH_STATUSES.includes(status);
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const modifiedReq = addToken(req, authService.getToken());

  return next(modifiedReq).pipe(
    timeout(environment.timeout),
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse
        && isRetryableAuthError(error.status)
        && !req.url.includes('/start')
      ) {
        authService.clearToken();
        return authService.ensureToken().pipe(
          switchMap(() => {
            const retryReq = addToken(req, authService.getToken());
            return next(retryReq).pipe(timeout(environment.timeout));
          })
        );
      }
      return throwError(() => error);
    })
  );
};
